import {
    createAsyncThunk
} from "@reduxjs/toolkit";
import api from "../../store/api/api"
import {
    headerConfiguration,
    headers
} from "../../store/auth/headerConfig";



export const searchDataset = createAsyncThunk(
    "datasets/searchDataset",
    async ({query,start_date,end_date,user_count}, {getState, dispatch}) => {

      const headerConfig = headerConfiguration(getState, headers)

      try {
        const url = `${process.env.REACT_APP_SERVER_URL}/api/marketplace/retrieve-profiles/`;
        const body = {
            query,
            start_date,
            end_date,
            user_count
        }
        const response = await api(url, "POST", headerConfig, body, dispatch);
        return response
      } catch (error) {
            // console.error(error)
            return (error?.message);
      }
    }
  );



export const getPurchasedSets = createAsyncThunk(
  "datasets/getPurchasedSets",
  async ({user_id}, {getState, dispatch}) => {

    const headerConfig = headerConfiguration(getState, headers)

    try {
      const url = `${process.env.REACT_APP_SERVER_URL}/api/marketplace/retrieve-datasets/${user_id}/`;
      const response = await api(url, "GET", headerConfig, null, dispatch);
      return response?.data
    } catch (error) {
          // console.error(error)
          return (error?.message);
    }
  }
);
